import React, { useEffect, useState, useContext } from "react";
import { SubjectDataContext } from "./SubjectRoot";
import Global from "../utils/Global";
import { TrialTable } from "../components/Tables/TrialTable";
import display_types from "../config/display_types";
import DropdownTable from "../components/Tables/DropdownTable";

export default function Reports() {
  // Get common data from context
  const { subject, display_type } = useContext(SubjectDataContext);
  
  // Local state for this component
  const [isTabLoading, setIsTabLoading] = useState(true);
  const [periodInformation, setPeriodInformation] = useState([]);
  const [selectedRowName, setSelectedRowName] = useState("");
  const [selectedRowId, setSelectedRowId] = useState("");
  const [trials, setTrials] = useState(null);

  // Fetch tab-specific data
  useEffect(() => {
    const fetchTabData = async () => {
      try {
        setIsTabLoading(true);
        
        const periodInformation = await Global.localAppHandler.app_retrieve_period_information({ 
          include_all_periods: true, 
          include_trials: true, 
          include_report: false 
        });
        
        const filteredPeriods = periodInformation.filter((period) => {
          const startDate = new Date(period.start_date);
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return startDate <= today; // Keep periods where start_date is before or on today
        });
        
        const trials = await Global.localAppHandler.app_get_trial_list();
        
        setPeriodInformation(filteredPeriods);
        setTrials(trials);
      } catch (error) {
        console.error("Error fetching reports data:", error);
      } finally {
        setIsTabLoading(false);
      }
    };

    // Only fetch if we have the subject data
    if (subject) {
      fetchTabData();
    }
  }, [subject]);

  // Show loading state
  if (isTabLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "300px", marginTop: "100px" }}>
        <div className="text-center">
          <div className="spinner-border mb-3" role="status" style={{ width: "3rem", height: "3rem" }}>
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="text-muted">Loading patient data...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container-xl px-4">
      {periodInformation.length > 0 && (display_type === display_types.PHI || display_type === display_types.NO_PHI_COLORADO) ? (
        periodInformation.reverse().map((period, index) => (
          <DropdownTable
            key={index}
            index={index}
            title={`Report For: ${period.start_date} - ${period.end_date}`}
            data={period.trials || []} // Assuming each period has a 'data' field
            report={null} // Adjust this based on your logic
          />
        ))
      ) : (
        <div className="card mb-4">
          <div className="card-body">
            <TrialTable
              trials={trials ? trials : []}
              allowTwoSelections={false}
              setSelectedRowName={setSelectedRowName}
              setSelectedRowId={setSelectedRowId}
              isLoading={isTabLoading}
            />
          </div>
        </div>
      )}
    </div>
  );
}